export type MedicalSupplyDefinition = {
  name: string
  slug: string
  sku: string
  image: string
  material: 'Latex' | 'Nitrile'
  powder: 'Dengan bedak' | 'Tanpa bedak'
  packSize: 50 | 100
  color?: string
}

export const MEDICAL_SUPPLY_DEFINITIONS: MedicalSupplyDefinition[] = [
  {
    name: 'Shamrock Nitrile Powder Free',
    slug: 'shamrock-nitrile-powder-free',
    sku: 'MED-SHAM-NITRILE-PF-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/76d68ca16b3647f2a60dce00d5799960.jpg',
    material: 'Nitrile',
    powder: 'Tanpa bedak',
    packSize: 100,
  },
  {
    name: 'Shamrock Latex Powder Free Black',
    slug: 'shamrock-latex-powder-free-black',
    sku: 'MED-SHAM-LATEX-PF-BLK-50',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/622e61dcef12489fad62a0c6e4524bac.jpg',
    material: 'Latex',
    powder: 'Tanpa bedak',
    packSize: 50,
    color: 'Hitam',
  },
  {
    name: 'NAYA Latex Powder Free',
    slug: 'naya-latex-powder-free',
    sku: 'MED-NAYA-LATEX-PF-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/4fd6ecf1ffb44757b9ff7e0fa3f88f4f.jpg',
    material: 'Latex',
    powder: 'Tanpa bedak',
    packSize: 100,
  },
  {
    name: 'NAYA Latex Powdered',
    slug: 'naya-latex-powdered',
    sku: 'MED-NAYA-LATEX-PWD-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/7655a74e3a1e4f879b80d8e1f88aeecc.jpg',
    material: 'Latex',
    powder: 'Dengan bedak',
    packSize: 100,
  },
  {
    name: 'Otoro Latex Powder Free',
    slug: 'otoro-latex-powder-free',
    sku: 'MED-OTORO-LATEX-PF-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/f7a724fdf91e4b9985f58739cc64c8ec.jpg',
    material: 'Latex',
    powder: 'Tanpa bedak',
    packSize: 100,
  },
  {
    name: 'Disposable Nitrile Powder Free Blue',
    slug: 'disposable-nitrile-powder-free-blue',
    sku: 'MED-DISP-NITRILE-PF-BLU-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/5cda59c811f14198a5ef65b9b8c78349.jpg',
    material: 'Nitrile',
    powder: 'Tanpa bedak',
    packSize: 100,
    color: 'Biru',
  },
  {
    name: 'Disposable Nitrile Powder Free Black',
    slug: 'disposable-nitrile-powder-free-black',
    sku: 'MED-DISP-NITRILE-PF-BLK-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/acaddc8de26149278b6ca9c741d1f8f3.jpg',
    material: 'Nitrile',
    powder: 'Tanpa bedak',
    packSize: 100,
    color: 'Hitam',
  },
  {
    name: 'Disposable Latex Powder Free Pink',
    slug: 'disposable-latex-powder-free-pink',
    sku: 'MED-DISP-LATEX-PF-PNK-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/42833073047648f68d7e66adec7d94cc.jpg',
    material: 'Latex',
    powder: 'Tanpa bedak',
    packSize: 100,
    color: 'Pink',
  },
  {
    name: 'Disposable Latex Powder Free Black',
    slug: 'disposable-latex-powder-free-black',
    sku: 'MED-DISP-LATEX-PF-BLK-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/d9fb4437f264476fad5ec6fb8ea8ff8a.jpg',
    material: 'Latex',
    powder: 'Tanpa bedak',
    packSize: 100,
    color: 'Hitam',
  },
  {
    name: 'Disposable Latex Powder Free',
    slug: 'disposable-latex-powder-free',
    sku: 'MED-DISP-LATEX-PF-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/5902d688aea34e68818323ba3a7eabc2.jpg',
    material: 'Latex',
    powder: 'Tanpa bedak',
    packSize: 100,
  },
  {
    name: 'Disposable Latex Powdered',
    slug: 'disposable-latex-powdered',
    sku: 'MED-DISP-LATEX-PWD-100',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/22/a8ddaa2d05c84bad839be0a511c3233f.jpg',
    material: 'Latex',
    powder: 'Dengan bedak',
    packSize: 100,
  },
]

export type MedicalMaskDefinition = {
  name: string
  slug: string
  sku: string
  image: string
  model: string
  packSize: 20 | 50
  note: string
}

export const MEDICAL_MASK_DEFINITIONS: MedicalMaskDefinition[] = [
  {
    name: 'Masker COMET Theo 3 Ply Earloop (Box 50 Pcs)',
    slug: 'masker-comet-theo-3-ply-earloop-box-50-pcs',
    sku: 'COMET-THEO-3PLY',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/530a439634b44ff7a3550bf8a0ff2e10.png',
    model: '3 ply',
    packSize: 50,
    note: 'Pilihan earloop dan headloop dengan warna hijau, hitam, dan putih. Data BFE 95% dan nomor AKD tersedia.',
  },
  {
    name: 'Masker COMET Theo 4D (Box 20 Pcs)',
    slug: 'masker-comet-theo-4d-box-20-pcs',
    sku: 'COMET-THEO-4D',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/909e7adc3a644a3cbe5ed1517dd03270.png',
    model: '4 ply 4D',
    packSize: 20,
    note: 'Bentuk 4D memberi ruang di depan mulut dan membantu mengurangi embun pada kacamata. Warna hitam, putih, abu, dan krem.',
  },
  {
    name: 'Masker COMET Theo KN95 (Box 20 Pcs)',
    slug: 'masker-comet-theo-kn95-box-20-pcs',
    sku: 'COMET-THEO-KN95',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/f23d771d9c18438595645ec75ba937d4.png',
    model: '5 ply KN95',
    packSize: 20,
    note: 'Konstruksi 5 ply dengan data BFE 98%. Warna hitam, putih, abu, dan krem.',
  },
  {
    name: 'Masker COMET Theo 4 Ply Carbon (Box 50 Pcs)',
    slug: 'masker-comet-theo-4-ply-carbon-box-50-pcs',
    sku: 'COMET-THEO-4PLYC',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/d5b7d0f57c674a8ca74d6c6190426cb5.png',
    model: '4 ply carbon',
    packSize: 50,
    note: 'Lapisan karbon aktif untuk area kerja berdebu dan berbau.',
  },
]

export const MEDICAL_DOCUMENTS = [
  { name: 'FDA 510(k)', scope: 'Clearance tersedia untuk model pemeriksaan tertentu. Nomor dokumen harus cocok dengan seri dan kemasan.' },
  { name: 'ISO 13485', scope: 'Sistem manajemen mutu alat kesehatan di tingkat produsen.' },
  { name: 'ISO 14001', scope: 'Sistem manajemen lingkungan di tingkat produsen.' },
  { name: 'ISO 45001', scope: 'Sistem manajemen keselamatan dan kesehatan kerja di tingkat produsen.' },
  { name: 'CPAKB / GMP', scope: 'Cara produksi alat kesehatan yang baik di tingkat produsen.' },
  { name: 'CE / MDR', scope: 'Dokumen kesesuaian pasar Eropa tersedia pada seri tertentu.' },
  { name: 'Halal', scope: 'Sertifikat berlaku pada produk yang tercantum dalam dokumen.' },
  { name: 'Food grade', scope: 'Klaim ASTM D7329 berlaku pada produk tertentu.' },
  { name: 'AKD & TKDN', scope: 'Nomor izin edar AKD Kemenkes dan data TKDN tersedia per varian untuk lini Shamrock, NAYA, dan Otoro. Sebagian varian tercantum di e-katalog LKPP.' },
]
